export default "__VITE_ASSET__DN8AWAEI__"